export interface IWebinar {
    id: number | string;
    title: string;
    subtitle: string;
    start_date: string;
    end_date: string;
    json_data: string;
    active?: number;
}

export const getDate = (date: string) => {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
};

export const getTimePeriod = (startDate: string, endDate: string) => {
    const dateObjStart = new Date(startDate);
    const minutesStart = String(dateObjStart.getUTCMinutes()).padStart(2, "0");
    const timeStart = String(dateObjStart.getUTCHours());

    const dateObjEnd = new Date(endDate);
    const minutesEnd = String(dateObjEnd.getUTCMinutes()).padStart(2, "0");
    const timeEnd = String(dateObjEnd.getUTCHours());

    return `${timeStart}:${minutesStart} - ${timeEnd}:${minutesEnd}`;
};

export const parseJson = (jsonData: string): Record<string, any> => {
    try {
        return JSON.parse(jsonData);
    } catch {
        return {};
    }
};

export const getAuthors = (jsonData: string): string => {
    const authors = parseJson(jsonData).authors;
    return Array.isArray(authors) ? authors.join(", ") : "";
};
